// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page_wrapper__W4fBR","content":"page_content__h_Cwk","breadcrumbs":"page_breadcrumbs__2w4CM"};